/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".cart-button-disabled-popover-content[_ngcontent-%COMP%]{width:130px}.cart-icon[_ngcontent-%COMP%]{font-size:24px}.cart-cta[_ngcontent-%COMP%]{font-size:15px;position:relative;top:-3px}.global-icon[_ngcontent-%COMP%]{font-size:24px}"];
export { styles as styles };
